import React from 'react';
import { useAppSelector } from '../../hooks/storeHooks';
import './TableHeader.scss';
import { ProtectAction } from '../../rbac';

interface TableHeaderProps {
  title: string;
  buttonLabel?: string;
  onAddTestClick?: () => void;
  wellTestDetails?: boolean;
  disableAddTest?: boolean;
  wellTestTable?: boolean;
  addIcon?: boolean;
  rPermission?: { [key: string]: boolean };
  tableName?: string;
  badge?: string;
}

const TableHeader: React.FC<TableHeaderProps> = ({
  title,
  buttonLabel = 'Add test',
  onAddTestClick,
  wellTestDetails,
  disableAddTest,
  addIcon = true,
  rPermission,
  tableName,
  badge,
}) => {
  const wellTestData = useAppSelector((state: any) => state.WellTestIdSlice?.data || '');

  return (
    <header className='cust-table-header pb-0 '>
      <div className='cust-table-header-wrap'>
        <div className='flex grow'>
          <h1 className='table-header-title'>
            <span
              className='title-ellipsis'
              title={`${title}${wellTestDetails ? ` - ${wellTestData?.Name ?? ''} / ${wellTestData?.Identifier ?? ''}` : ''}`}
            >
              {title}
              {badge && <span className='selected-wells-msg'>{badge}</span>}
              {wellTestDetails ? ` - ${wellTestData?.Name ?? ''} / ${wellTestData?.Identifier ?? ''}` : ''}
            </span>
          </h1>
        </div>
        {onAddTestClick && (
          <ProtectAction
            canAccess={
              (tableName == 'Well Test' && rPermission?.canAddTest) ||
              (tableName == 'taskDetail' && rPermission?.canAdd) ||
              (tableName == 'wellNotes' && rPermission?.canAdd) ||
              rPermission?.unProtected
            }
          >
            <button
              analytics-id='table-header-add-test-btn'
              className='btn-prime'
              onClick={onAddTestClick}
              disabled={disableAddTest}
            >
              {addIcon && <span className='ico-add' />}
              <span className='text-button'>{buttonLabel}</span>
            </button>
          </ProtectAction>
        )}
      </div>
    </header>
  );
};

export default TableHeader;
